<p-accordionTab>
    <p-header>
      <div class="ui-helper-clearfix">
        <div class="left">
          <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">ECU Message (AT+GTECM)</span>
        </div>
      </div>
    </p-header>
  
    <div class="row align-items-center">
  
      <div class="col row dvcFields">
        <div class="col lblStyle">
          <form-input fieldName="Group ID">
          </form-input>
        </div>
        <div class="col">
            <div class="ui-inputgroup">
                <p-spinner size="5" step="1" [(ngModel)]="ecmParameters.groupId" [min]="0" [max]="4"></p-spinner>
                <span class="ui-inputgroup-addon">0~4</span>
            </div>
        </div>
      </div>
    </div>
    <div class="row align-items-center"> 
        <div class="col row dvcFields">
          <div class="col lblStyle">
            <form-input fieldName="Mode">
            </form-input>
          </div>
          <div class="col">
            <p-dropdown [options]="modeOptions" [(ngModel)]="ecmParameters.mode"
              [style]="{'width':'100%','min-width':'100px'}"></p-dropdown>
          </div>
        </div>
      </div>
      
      <div class="row align-items-center">
        <form-input fieldName="Report Item Mask"></form-input>
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="ECU Type" [(ngModel)]="ecmParameters.ecuType">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="ECU Lock State" [(ngModel)]="ecmParameters.ecuLockState">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Bike Type" [(ngModel)]="ecmParameters.bikeType">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Serial Number of the Bike" [(ngModel)]="ecmParameters.serialNumberBike">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Serial Number of the Bike Battery" [(ngModel)]="ecmParameters.serialNumberBikeBattery">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Bike Software Version" [(ngModel)]="ecmParameters.bikeSoftwareVersion">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Battery Software Version" [(ngModel)]="ecmParameters.batterySoftwareVersion">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Controller Software Version" [(ngModel)]="ecmParameters.controllerSoftwareVersion">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Display Software Version" [(ngModel)]="ecmParameters.displaySoftwareVersion">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Bike Status" [(ngModel)]="ecmParameters.bikeStatus">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Odometer" [(ngModel)]="ecmParameters.odometer">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Bike Design Capacity" [(ngModel)]="ecmParameters.bikeDesignCapacity">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Bike Full Charge Capacity (FCC) Raw" [(ngModel)]="ecmParameters.bikeFccRaw">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Bike Full Charge Capacity (FCC) Percentage" [(ngModel)]="ecmParameters.bikeFccPercentage">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Bike Actual State of Charge (SOC) Raw" [(ngModel)]="ecmParameters.bikeSocRaw">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Bike Actual state of Charge (SOC) Percentage" [(ngModel)]="ecmParameters.bikeSocPercentage">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Bike Range" [(ngModel)]="ecmParameters.bikeRange">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Bike Battery Temperature" [(ngModel)]="ecmParameters.bikeBatteryTemperature">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Bike Battery Charging Cycles" [(ngModel)]="ecmParameters.bikeBatteryChargingCycles">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Bike Battery Pack Voltage" [(ngModel)]="ecmParameters.bikeBatteryPackVoltage">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Nominal Pack Voltage" [(ngModel)]="ecmParameters.nominalPackVoltage">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Actual Current" [(ngModel)]="ecmParameters.actualCurrent">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Bike Battery Cell Voltages" [(ngModel)]="ecmParameters.bikeBatteryCellVoltages">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Charging Interval" [(ngModel)]="ecmParameters.chargingInterval">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Battery Error Code" [(ngModel)]="ecmParameters.batteryErrorCode">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Battery State" [(ngModel)]="ecmParameters.batteryState">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Electronics Temperature" [(ngModel)]="ecmParameters.electronicTemperature">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Wheel Diameter" [(ngModel)]="ecmParameters.wheelDiameter">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Motor Temperature" [(ngModel)]="ecmParameters.motorTemperature">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Support Mode" [(ngModel)]="ecmParameters.supportMode">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Light Status" [(ngModel)]="ecmParameters.lightStatus">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Motor Error Code" [(ngModel)]="ecmParameters.motorErrorCode">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Bike Wheel Speed" [(ngModel)]="ecmParameters.bikeWheelSpeed">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Pedal Cadence" [(ngModel)]="ecmParameters.pedalCadence">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Actual Motor Torque" [(ngModel)]="ecmParameters.actualMotorTorque">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Maximum Motor Torque" [(ngModel)]="ecmParameters.maxMotorTorque">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Motor Power" [(ngModel)]="ecmParameters.motorPower">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Pedal Power" [(ngModel)]="ecmParameters.pedalPower">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Bike Speed" [(ngModel)]="ecmParameters.bikeSpeed">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Pedal Torque" [(ngModel)]="ecmParameters.pedalTorque">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Controller Serial Number" [(ngModel)]="ecmParameters.controllerSerialNumber">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Display Serial Number" [(ngModel)]="ecmParameters.displaySerialNumber">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="DC-DC Serial Number" [(ngModel)]="ecmParameters.dcSerialNumber">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="DC-DC Software Version" [(ngModel)]="ecmParameters.dcSoftwareVersion">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="POD Serial Number" [(ngModel)]="ecmParameters.podSerialNumber">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="POD Software Version" [(ngModel)]="ecmParameters.podSoftwareVersion">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Last Recharge Date" [(ngModel)]="ecmParameters.lastRechargeDate">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="MOSFET Temperature U/V/W" [(ngModel)]="ecmParameters.mosfetTemperature">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Riding Mode" [(ngModel)]="ecmParameters.ridingMode">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Daylight Status" [(ngModel)]="ecmParameters.daylightStatus">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Controller ODO Meter" [(ngModel)]="ecmParameters.controllerOdometer">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Walk Assist Status" [(ngModel)]="ecmParameters.walkAssistStatus">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Trip Counter" [(ngModel)]="ecmParameters.tripCounter">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Charger Connected" [(ngModel)]="ecmParameters.chargeConnected">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Speed Limit" [(ngModel)]="ecmParameters.speedLimit">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Park Brake Status" [(ngModel)]="ecmParameters.parkBrakeStatus">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Pin TH4 Level" [(ngModel)]="ecmParameters.pinth4Level">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Pin TH6 Level" [(ngModel)]="ecmParameters.pinth6Level">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Pin TH12 Level" [(ngModel)]="ecmParameters.pinth12Level">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Pin TH14 Level" [(ngModel)]="ecmParameters.pinth14Level">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Controller Current Rating" [(ngModel)]="ecmParameters.controllerCurrentRating">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Time Powered up" [(ngModel)]="ecmParameters.timePoweredUp">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Power up Count" [(ngModel)]="ecmParameters.powerupCount">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Time Driving" [(ngModel)]="ecmParameters.timeDriving">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Drive Count" [(ngModel)]="ecmParameters.driveCount">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Deep Discharge Count" [(ngModel)]="ecmParameters.deepDischargeCount">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Overcharge Count" [(ngModel)]="ecmParameters.overChargeCount">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Condition Code" [(ngModel)]="ecmParameters.conditionCode">
                </p-checkbox>
            </div>
            <div class="col">
                <p-checkbox binary="true" label="Active Flash Code" [(ngModel)]="ecmParameters.activeFlashCode">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Ambient Temperature" [(ngModel)]="ecmParameters.ambientTemperature">
                </p-checkbox>
            </div>
            <div class="col">
            </div>
            <div class="col">
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <form-input fieldName="Active Triggers Mask"></form-input>
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Active when external power supply connected" [(ngModel)]="ecmParameters.activeExternalPowerConnected">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Active when movement detected" [(ngModel)]="ecmParameters.activeMovementDetected">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Active by ACC on" [(ngModel)]="ecmParameters.activeAccOn">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Active when external battery is charging" [(ngModel)]="ecmParameters.activeExternalBatteryCharging">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
        <div class="col row dvcFields">
            <div class="col">
                <p-checkbox binary="true" label="Active when ECU status is ON" [(ngModel)]="ecmParameters.activeECUStatusOn">
                </p-checkbox>
            </div>
        </div>       
    </div>
    <div class="row align-items-center">
  
        <div class="col row dvcFields">
          <div class="col lblStyle">
            <form-input fieldName="Backup Battery Active Send Interval">
            </form-input>
          </div>
          <div class="col">
              <div class="ui-inputgroup">
                  <p-spinner size="5" step="1" [(ngModel)]="ecmParameters.backupBatteryActiveInterval" [min]="0" [max]="604800"></p-spinner>
                  <span class="ui-inputgroup-addon">0~604800</span>
                  <span class="ui-inputgroup-addon">sec</span>
              </div>
          </div>
        </div>
    </div>
    <div class="row align-items-center">
  
        <div class="col row dvcFields">
          <div class="col lblStyle">
            <form-input fieldName="Backup Battery Inactive Send Interval">
            </form-input>
          </div>
          <div class="col">
              <div class="ui-inputgroup">
                  <p-spinner size="5" step="1" [(ngModel)]="ecmParameters.backupBatteryInactiveInterval" [min]="0" [max]="604800"></p-spinner>
                  <span class="ui-inputgroup-addon">0~604800</span>
                  <span class="ui-inputgroup-addon">sec</span>
              </div>
          </div>
        </div>
    </div>
    <div class="row align-items-center">
  
        <div class="col row dvcFields">
          <div class="col lblStyle">
            <form-input fieldName="External Battery Active Send Interval">
            </form-input>
          </div>
          <div class="col">
              <div class="ui-inputgroup">
                  <p-spinner size="5" step="1" [(ngModel)]="ecmParameters.externalBatteryActiveInterval" [min]="0" [max]="604800"></p-spinner>
                  <span class="ui-inputgroup-addon">0~604800</span>
                  <span class="ui-inputgroup-addon">sec</span>
              </div>
          </div>
        </div>
    </div>
    <div class="row align-items-center">
  
        <div class="col row dvcFields">
          <div class="col lblStyle">
            <form-input fieldName="External Battery Inactive Send Interval">
            </form-input>
          </div>
          <div class="col">
              <div class="ui-inputgroup">
                  <p-spinner size="5" step="1" [(ngModel)]="ecmParameters.externalBatteryInactiveInterval" [min]="0" [max]="604800"></p-spinner>
                  <span class="ui-inputgroup-addon">0~604800</span>
                  <span class="ui-inputgroup-addon">sec</span>
              </div>
          </div>
        </div>
    </div>


  </p-accordionTab>